import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import FormattedList from 'I18n/components/FormattedList';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersSimpleEnumValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const tags = condition.value.toArray().map(value => {
    const valueOption = condition.field && condition.field.options && condition.field.options.find(option => option.value === value);
    if (!valueOption) {
      return {
        label: value,
        value
      };
    }
    return {
      label: valueOption.label,
      value
    };
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return /*#__PURE__*/_jsx(FormattedList, {
      exclusive: true,
      children: tags.map(({
        label
      }) => /*#__PURE__*/_jsx("span", {
        children: label
      }, `quick-filter-simple-enum-${label}`))
    });
  }
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: onValueDelete
  });
};
export default QuickFiltersSimpleEnumValueDisplay;